import type { Model } from '../../types';
import type { Account } from '../../types/Account';

import effects from './effects';
import selectors from './selectors';

export type AccountState = Partial<Account> & {
  userLimits?: number;
};

const reducers = {
  'session/clear': () => account.state,
  update: (state: AccountState, payload: AccountState) => ({ ...state, ...payload })
};

const account: Model<AccountState, typeof reducers, void, typeof effects, typeof selectors> = {
  state: {},
  effects,
  reducers,
  selectors
};

export default account;
